import { render, staticRenderFns } from "./IdeaSpaces.vue?vue&type=template&id=181d74ed&scoped=true"
import script from "./IdeaSpaces.vue?vue&type=script&lang=js"
export * from "./IdeaSpaces.vue?vue&type=script&lang=js"
import style0 from "./IdeaSpaces.vue?vue&type=style&index=0&id=181d74ed&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181d74ed",
  null
  
)

export default component.exports